import { render, staticRenderFns } from "./otherNav.vue?vue&type=template&id=941efb04&scoped=true&"
import script from "./otherNav.vue?vue&type=script&lang=js&"
export * from "./otherNav.vue?vue&type=script&lang=js&"
import style0 from "./otherNav.vue?vue&type=style&index=0&id=941efb04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941efb04",
  null
  
)

export default component.exports